<template>
  <div data-cy="card_cartao_container">
    <v-card
      v-for="(item, index) in lista"
      :key="item.card_id"
      class="mt-6"
      data-cy="card_cartao"
    >
      <div class="d-flex flex-no-wrap">
        <div class="left">
          <v-img
            alt="Logo da bandeira do cartão"
            height="32"
            width="32"
            contain
            class="ml-4 mt-4"
            :src="require(`@/assets/img/logocartoes/${bandeiraCartao(item.brand)}`)"
          />
        </div>

        <div class="right pt-4 flex-grow-1">
          <v-card-title
            v-if="item.nickname"
            class="body-1 py-0 pr-10 text-truncate d-block"
            data-cy="apelido"
          >
            {{ item.nickname }}
          </v-card-title>

          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                class="mais-opcoes"
                data-cy="btn_mais_acoes"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-show="!item.is_main"
                data-cy="btn_tornar_principal"
                @click="tornarPrincipal(index, item.card_id)"
              >
                <v-list-item-title>Tornar principal</v-list-item-title>
              </v-list-item>
              <v-list-item
                data-cy="btn_excluir_cartao"
                @click="excluirCartao(item.is_main, item.number, item.card_id)"
              >
                <v-list-item-title>Excluir</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-card-text class="pt-0">
            <p class="mb-0" data-cy="ultimos_digitos">
              Final {{ item.number }}
            </p>
            <p
              class="mb-0"
              :class="[item.is_main ? '' : 'mb-7']"
              data-cy="vencimento"
            >
              Vencimento: {{ item.expiration_date }}
            </p>

            <v-chip
              v-if="item.is_main"
              :class="$vuetify.breakpoint.mdAndUp ? 'tag-principal' : ''"
              label
              outlined
              color="primary--text mt-1"
            >
              Principal
            </v-chip>
          </v-card-text>
        </div>
      </div>
    </v-card>
    <ModalConfirmacao
      :show-dialog="abrirModalConfirmacao"
      @changeDialog="retornoModalExcluir($event)"
    >
      <template slot="titulo">
        Excluir cartão
      </template>
      <template slot="texto">
        Deseja excluir o cartão de final {{ numeroFinaisCartao }}?
      </template>
      <template slot="btFalse">
        Não
      </template>
      <template slot="btTrue">
        Sim
      </template>
    </ModalConfirmacao>
  </div>
</template>

<script>
import ModalConfirmacao from '@/components/MeuPerfil/ModalConfirmacao.vue';

export default {
  name: 'ListaCartoes',

  components: {
    ModalConfirmacao,
  },

  props: {
    lista: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      abrirModalConfirmacao: false,
      idCartao: '',
      numeroFinaisCartao: '',
      listaBandeiras: [
        'american-express',
        'amex',
        'aura',
        'dinersclub',
        'diners',
        'discover',
        'elo',
        'hipercard',
        'jcb',
        'maestro',
        'mastercard',
        'visaelectron',
        'visa',
      ],
    };
  },

  methods: {
    bandeiraCartao(value) {
      if (!this.listaBandeiras.includes(value)) return 'cartao-default.svg';
      return `${value}.png`;
    },

    excluirCartao(principal, numero, id) {
      this.abrirModalConfirmacao = true;
      this.numeroFinaisCartao = numero;
      this.idCartao = id;
    },

    retornoModalExcluir(value) {
      if (value) {
        this.$emit('excluirCartao', this.idCartao);
      }
      this.abrirModalConfirmacao = false;
    },

    tornarPrincipal(index, id) {
      this.$emit('setCartaoPrincipal', index, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.mais-opcoes {
  position: absolute;
  right: 5px;
  top: 10px;
}
.tag-principal{
  position: absolute;
  right: 56px;
  top: 15px
}
</style>
